import { CollaboTypes } from '../types/collaboTypes'
import collaboService from 'src/services/collabo'
import { action } from 'typesafe-actions'
import { getErrorHelper } from 'src/utils/response-helpers'

export const getAllCollaboInvitesAction = () => {
  return async (dispatch: any) => {
    dispatch(action(CollaboTypes.GET_COLLABO_INVITES_CALL))
    try {
      const response: any = await collaboService.getAllcollaboInvites()
      dispatch(
        action(
          CollaboTypes.GET_COLLABO_INVITES_SUCCESS,
          response.data.data.collaboInvites
        )
      )
    } catch (error: any) {
      console.log(error.message)
    }
  }
}
export const getAllCollaboAction = () => {
  return async (dispatch: any) => {
    dispatch(action(CollaboTypes.GET_ALL_COLLABO_CALL))
    try {
      const response: any = await collaboService.getAllcollabo()
      dispatch(
        action(
          CollaboTypes.GET_ALL_COLLABO_SUCCESS,
          response.data.data.collaboPlans
        )
      )
    } catch (error: any) {
      console.log(error.message)
    }
  }
}
export const rejectCollaboInvitetAction = (id: string) => {
  return async (dispatch: any) => {
    dispatch(action(CollaboTypes.REJECT_COLLABO_INVITE_CALL))
    try {
      const response: any = await collaboService.rejectcollaboInvite(id)
      dispatch(
        action(CollaboTypes.REJECT_COLLABO_INVITE_SUCCESS, response.data.data)
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
export const acceptCollaboInvitetAction = (payload: any) => {
  const { collabo } = payload

  return async (dispatch: any) => {
    dispatch(action(CollaboTypes.ACCEPT_COLLABO_INVITE_CALL))
    try {
      const response: any = await collaboService.acceptcollaboInvite(collabo)
      dispatch(
        action(CollaboTypes.ACCEPT_COLLABO_INVITE_SUCCESS, response.data.data)
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}

export const searchUserAction = (payload: any) => {
  return async (dispatch: any) => {
    dispatch(action(CollaboTypes.SEARCH_INVITEE_CALL))
    try {
      const response: any = await collaboService.searchUser(payload)
      dispatch(
        action(CollaboTypes.SEARCH_INVITEE_SUCCESS, response.data.data.user)
      )
    } catch (error) {
      getErrorHelper(error)
    }
  }
}
